/*
 * axios 0.x 와 동일한 GET 파라미터 직렬화.
 *
 * v2 레거시 서버는 중첩 객체 파라미터를 "JSON 문자열"로 받아 JSON.parse 하는 계약이다.
 *   예) isRemoved={"$ne":true}, removedAt={"$gte":"...","$lte":"..."}
 * axios 1.x 기본 직렬화는 bracket 표기(isRemoved[$ne]=true)로 바뀌어 서버 필터가
 * 통째로 깨지므로 0.x 방식을 복원해 주입
 * 
 * @ref https://github.com/axios/axios/issues/5630
 * @ref https://axios.rest/pages/getting-started/upgrade-guide#parameter-serialization
 */

// axios 0.x buildURL 의 encode 와 동일 — RFC3986 중 서버가 기대하는 문자는 되살린다
const encode = (val: string): string =>
  encodeURIComponent(val)
    .replace(/%3A/gi, ':')
    .replace(/%24/g, '$')
    .replace(/%2C/gi, ',')
    .replace(/%20/g, '+')
    .replace(/%5B/gi, '[')
    .replace(/%5D/gi, ']')

export const serializeParamsLikeAxios0 = (params: Record<string, unknown>): string => {
  const parts: string[] = []

  Object.entries(params ?? {}).forEach(([key, value]) => {
    if (value === null || value === undefined) return

    let values: unknown[]
    if (Array.isArray(value)) {
      key = key + '[]'
      values = value
    } else {
      values = [value]
    }

    values.forEach((v) => {
      if (v instanceof Date) {
        v = v.toISOString()
      } else if (typeof v === 'object') {
        // moment 객체도 toJSON 을 통해 ISO 문자열로 직렬화된다
        v = JSON.stringify(v)
      }
      parts.push(`${encode(key)}=${encode(String(v))}`)
    })
  })

  return parts.join('&')
}
